/***
 *
 *   HOME NAV
 *   Navigation used on the main external website. Renders a dashboard link
 *   if the user is signed in, or a sign up link if they are not
 *
 **********/

import { AuthContext, ClassHelper, Logo } from "components/lib";
import { useContext, useEffect } from "react";
import Style from "./home.module.scss";

export function HomeNav(props) {
  // context
  const context = useContext(AuthContext);

  useEffect(() => {
    if (context.user && context.user.token) {
      window.location = "/admin/dashboard";
    }
  }, [context]);

  const css = ClassHelper(Style, {
    wrapper: true,
    color: !props.transparent,
    transparent: props.transparent,
  });

  return (
    <section className={css}>
      <Logo className={Style.logo} />
    </section>
  );
}
